import { Component, Input, OnInit } from '@angular/core';
import { AuthStorage } from 'src/app/client/repositories/lib/auth';
import { ScreenBreakpointObserverService } from 'src/app/shared/foundation/utils/breakpoint-observer.service';

@Component({
  selector: 'app-content-wrapper',
  templateUrl: './content-wrapper.component.html',
  styleUrls: ['./content-wrapper.component.scss'],
})
export class ContentWrapperComponent implements OnInit {
  @Input() title?: string;
  isMobileLayout = false;
  isSignedIn: boolean;

  constructor(
    private bpObserverService: ScreenBreakpointObserverService,
    private authStorage: AuthStorage
  ) {}

  ngOnInit(): void {
    this.bpObserverService.screenSizeObserver.subscribe({
      next: (res) => {
        if (res.length <= 2) {
          this.isMobileLayout = true;
        } else {
          this.isMobileLayout = false;
        }
      },
    });

    if (
      this.authStorage.getCredential() &&
      localStorage.getItem('confirmed') === 'true'
    ) {
      this.isSignedIn = true;
    } else {
      this.isSignedIn = false;
    }
  }
}
